export const changeThemes = (theme) => ({
  type: "themeChange",
  payload: theme,
});
